import { ToggleValue } from 'components/Admin/Shared/Toggle'

export function settingsTotoggleValue(settings, setting: string) {
  if (settings == null) {
    return ToggleValue.PRIVATE
  }

  if (setting in settings) {
    return settings[setting]['isPublic'] === true
      ? ToggleValue.PUBLIC
      : ToggleValue.PRIVATE
  }

  return ToggleValue.PRIVATE
}

export function differenceInDays(date1: Date, date2: Date): number {
  const millisPerDay = 1000 * 60 * 60 * 24 // Number of milliseconds in one day
  const differenceInMilliseconds = date1.getTime() - date2.getTime()
  return Math.round(differenceInMilliseconds / millisPerDay)
}
